import styled from 'styled-components';
import { s } from './VIPReport.style';
import { IReportData } from '../../../service/quant/Quant';

const ExpectedSaleAndProfit = ({
  data,
}: {
  data?: IReportData['marginAnalysis'];
}) => {
  return (
    <s.Div>
      <s.Title>💰예상 매각가 및 시세차익 분석</s.Title>
      <s.Table>
        <s.TableHeader>
          <s.Header>항목</s.Header>
          <s.Header>금액</s.Header>
        </s.TableHeader>
        <s.Row>
          <RowLeft>
            예상 시세<RowMiddle>AI 시세 기준</RowMiddle>
          </RowLeft>

          <RowRight>
            {data?.aiPrc ? data?.aiPrc.toLocaleString() : '-'} 원
          </RowRight>
        </s.Row>
        <s.Row>
          <RowLeft>
            예상 매각가
            <RowMiddle>
              시세 대비{' '}
              {data?.salePrc && data?.aiPrc
                ? ((data?.salePrc / data?.aiPrc) * 100).toFixed(2)
                : '-'}
              %
            </RowMiddle>
          </RowLeft>

          <RowRight>
            {data?.salePrc ? data?.salePrc.toLocaleString() : '-'} 원
          </RowRight>
        </s.Row>
        <s.Row style={{ backgroundColor: '#F0F8FF' }}>
          <RowLeft>
            예상 매각차익<RowMiddle>매각가-입찰가</RowMiddle>
          </RowLeft>

          <RowRight style={{ color: '#008AFF' }}>
            {data?.margin ? data?.margin.toLocaleString() : '-'} 원
          </RowRight>
        </s.Row>
      </s.Table>
    </s.Div>
  );
};

export default ExpectedSaleAndProfit;

const RowLeft = styled.div`
  width: 50%;
  height: 68px;
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
  padding: 16px;
  font-size: 13px;
`;

const RowMiddle = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: #616161;
`;

const RowRight = styled.div`
  width: 50%;
  padding: 16px;
  height: 68px;
  display: flex;
  align-items: center;
  justify-content: end;
`;
